import { Injectable, inject } from "@angular/core";
import { BaseApiService } from "../base/base-api.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ExportService {
  private baseApiService = inject(BaseApiService);
  private http = inject(HttpClient);

  async getExport(startDate: Date, endDate: Date): Promise<Blob> {
    const params = new HttpParams()
      .set("startDate", startDate.toISOString())
      .set("endDate", endDate.toISOString());

    const response = await lastValueFrom(
      this.http.get(`${this.baseApiService.rootUrl}/response-export`, {
        params: params,
        responseType: "blob",
      }),
    );
    return response;
  }
}
